import {
    universalDepositsSlideHypotises,
    pensCardSlide,
    higthDepositRatesSlide,
    propertyDeductionMainSlide,
    premiumDepositsSlide,
    mirChildMainSlide,
    winterDepositsSlide,
    homeMortgageChildrenSlide,
} from '@/core/models/common/MainSliderSlides/HomePage/HomePageSlidesModel';

import {
    mobileBankServiceSlide,
    finEducationServiceSlide,
    onlineServiceSlide,
    greenVectorServiceSlide,
} from '@/core/models/common/OfferSliderSlides/OtherSlidesModel';

import {
    stickerSlideHomePage,
    supportMeasuresHomePage,
} from '@/core/models/common/MainSliderSlides/Individuals/IndividualsSlidesModel';

const slidesData = [
    universalDepositsSlideHypotises,
    higthDepositRatesSlide,
    homeMortgageChildrenSlide,
    winterDepositsSlide,
    pensCardSlide,
    mirChildMainSlide,
    supportMeasuresHomePage,
    stickerSlideHomePage,
    premiumDepositsSlide,
    propertyDeductionMainSlide,
];

const calcConfig = {
    creditTypes: {
        model: 'mortgage',
        types: [{
            id: 'credit',
            name: 'Кредит наличными',
        },
        {
            id: 'autocredit',
            name: 'Автокредит',
        },
        {
            id: 'mortgage',
            name: 'Ипотека',
        }],
    },
};

const usefulCards = [
    mobileBankServiceSlide,
    finEducationServiceSlide,
    greenVectorServiceSlide,
    onlineServiceSlide,
];

export {
    slidesData,
    calcConfig,
    usefulCards,
};
